import styled from "styled-components";
import { TOP_NAV_HEIGHT } from "../../constants";

export const StyledFeedList = styled.div`
  display: flex;
  flex-direction: column;
  // 168px represents the StyledStatusBar which we intend to stay fixed while we scroll through FeedListItems
  // 80px represents the padding on top and bottom of the Home container combined
  max-height: ${props =>
    props.expand ? null : `calc(100vh - ${TOP_NAV_HEIGHT} - 168px - 80px)`};
  min-height: ${props => (props.expand ? null : "370px")};
  overflow: ${props => (props.expand ? null : "scroll")};
`;

export const EmptyFeedList = styled.div`
  // Center Text within StatusBar
  width: 920px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const FeedListHeader = styled.div`
  // Gives the same padding as the FeedListItem
  padding: 0px 32px 0px 20px;
  // Now 200px more since the header doesn't contain a StatusIcon or NameContainer
  margin-left: 180px;
  margin-bottom: 10px;

  display: flex;
  color: #6e6f9b;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: -0.13px;

  > div {
    display: flex;
    align-items: flex-end;
  }
`;

export const FeedListItem = styled.div`
  display: flex;
  align-items: center;
  :not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const FeedListItemContent = styled.div`
  width: 900px;
  padding: 32px 35px 32px 20px;
  margin-right: 16px;
  display: flex;
  background: #ffffff;
  color: #2a2a3d;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: -0.22px;
  border: 1px solid rgba(155, 155, 194, 0.3);
  border-radius: 2px;
  line-height: 36px;
  cursor: pointer;
`;

export const StatusIcon = styled.div`
  margin-right: 20px;
  width: 30px;
  min-width: 30px;

  svg {
    width: 30px;
    height: 24px;
  }
`;

export const FeedItemStatusIcon = styled(StatusIcon)`
  svg {
    width: 20px;
    height: 16px;
  }
`;

export const Cell = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
  color: ${props => (props.isNull ? "#babac8" : null)};
`;

export const NameContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Name = styled(Cell)`
  margin-right: 60px;
  width: 70px;
  min-width: 70px;

  :first-child {
    font-size: 18px;
    letter-spacing: -0.26px;
    line-height: 18px;
    font-weight: 700;
    margin-bottom: 4px;
  }

  :nth-child(2) {
    font-size: 11px;
    letter-spacing: 0.61px;
    line-height: 14px;
    color: #212530;
  }
`;

export const Type = styled(Cell)`
  width: 70px;
  min-width: 70px;
`;

export const Country = styled(Cell)`
  width: 45px;
  min-width: 45px;
`;

export const PbseVersion = styled(Cell)`
  width: 45px;
  min-width: 45px;
`;

export const Start = styled(Cell)`
  width: 45px;
  min-width: 45px;
`;

export const End = styled(Cell)`
  width: 45px;
  min-width: 45px;
`;

export const Rows = styled(Cell)`
  width: 80px;
  min-width: 80px;
`;

export const Devices = styled(Cell)`
  width: 40px;
  min-width: 40px;
`;

export const DevicesHeader = styled(Devices)`
  width: 60px;
  min-width: 60px;
  // 20px more margin than Cell because it's 20px less wide than Devices
  margin-right: 10px;
`;

export const Networks = styled(Cell)`
  width: 60px;
  min-width: 60px;
`;

export const Airings = styled(Cell)`
  width: 80px;
  min-width: 80px;
`;

export const AiringsHeader = styled(Airings)`
  width: 60px;
  min-width: 60px;
  // 20px more margin than Cell because it's 20px less wide than Airings
  margin-right: 40px;
`;

export const Brands = styled(Cell)`
  width: 45px;
  min-width: 45px;

  // Last cell in the table, doesn't need margin
  margin-right: 40px;
`;

export const Titles = styled(Cell)`
  width: 40px;
  min-width: 40px;
  margin-right: 40px;
`;
